<template>
  <table class="h-table account-history">
    <thead>
      <tr>
        <th
          v-for="column in columns"
          :key="column.id"
          class="h-table__col-title"
        >
          {{ column.fullName }}
        </th>
      </tr>
    </thead>

    <!-- Список операций -->
    <transition name="slide">
      <tbody class="slide-transition">
        <tr v-if="operations" class="h-table__row h-table__header-row" style="text-align: right;">
          <td></td>
          <td></td>
          <td class="positive-number">{{ this.totalDeposit.toFixed(2) }}</td>
          <td class="negative-number">{{ this.totalWithdraw.toFixed(2) }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr
          v-for="operation in operations"
          :key="operation.id.value"
          class="h-table__row"
        >
          <cell
            v-for="column in columns"
            :key="column.id"
            :column="column"
            :operation="operation"
          />
        </tr>
      </tbody>
    </transition>
  </table>
</template>

<script>
import Cell from "./cell-new";

export default {
  components: { Cell },
  props: ["columns", "operations"],
  data() {
    return {
      totalDeposit: 0,
      totalWithdraw: 0,
    }
  },
  methods: {
    sort(column) {
      if (!column) return;
      this.$emit("sort", column);
    },
    remove(transaction) {
      this.$emit("remove", transaction);
    },
    restore(transaction) {
      this.$emit("restore", transaction);
    },
  },
  watch: {
    operations: {
      handler() {
        this.totalDeposit = 0;
        this.totalWithdraw = 0;

        this.operations.forEach(operation => {
          if (operation.added_amount.value && !isNaN(Number(operation.added_amount.value))) this.totalDeposit += operation.added_amount.value
        })

        this.operations.forEach(operation => {
          if (operation.withdraw_amount.value && !isNaN(Number(operation.withdraw_amount.value))) this.totalWithdraw -= operation.withdraw_amount.value
        })
      },
      deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
.account-history {
  & /deep/ tr.collapsing {
    transition: font 0.5s ease;
  }

  thead th {
    text-align: left !important;
    vertical-align: top;
  }
}
.positive-number {
  background-color: #D0F4E3;
  display: table-cell;
  border: 1px solid #dfe4ef;
  
  &::before {
    display: none;
  }
}
.negative-number {
  background-color: #FFE6F2;
  display: table-cell;
  border: 1px solid #dfe4ef;
}

.h-table__header-row {
  background-color: #f5f7fa;
  border: 1px solid #dfe4ef;
  td {
    border: unset;
  }
}
</style>
